<template>
  <div class="placeholder-page">
    <div class="placeholder-card">
      <a-icon :type="displayIcon" class="placeholder-icon" />
      <h2>{{ displayTitle }}</h2>
      <p>{{ displayDesc }}</p>
      <a-tag color="blue">一期规划中</a-tag>
    </div>
  </div>
</template>

<script>
export default {
  name: "DispatchPlaceholder",
  props: {
    title: { type: String, default: "" },
    desc: { type: String, default: "" },
    icon: { type: String, default: "" },
  },
  computed: {
    displayTitle() {
      return this.title || (this.$route.meta && this.$route.meta.placeholderTitle) || "功能开发中";
    },
    displayDesc() {
      return this.desc || (this.$route.meta && this.$route.meta.placeholderDesc) || "该模块将在后续版本上线";
    },
    displayIcon() {
      return this.icon || (this.$route.meta && this.$route.meta.placeholderIcon) || "tool";
    },
  },
};
</script>

<style scoped>
.placeholder-page {
  padding: 3rem 1.5rem;
  display: flex;
  justify-content: center;
}

.placeholder-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 1rem;
  padding: 3rem;
  text-align: center;
  max-width: 420px;
}

.placeholder-icon {
  font-size: 3rem;
  color: #0082d4;
  margin-bottom: 1rem;
}

.placeholder-card h2 {
  margin: 0 0 0.5rem;
  color: #0f172a;
}

.placeholder-card p {
  color: #64748b;
  margin: 0 0 1rem;
}
</style>
